import React from 'react';

export default function PageGenerator(props) {
  const { post_templates, slug, meta, ...otherProps } = props;
  const children = post_templates
    .map(({ acf_fc_layout, ...componentProps }, idx) => {
      try {
        const Component = require(`components/templates-post/${acf_fc_layout}`)
          .default;
        return (
          <Component
            {...componentProps}
            {...otherProps}
            key={`${acf_fc_layout}-${idx}`}
          />
        );
      } catch (e) {
        return null;
      }
    })
    .filter(component => component);
  return (
    <>
      {children}
    </>
  );
}
